import store from '@/vue-instance/store';

export const campAuthMiddleware = (to, from, next) => {
  if (!store.getters['camp/auth/isLoggedIn'] || store.getters['camp/auth/isTokenExpired']) {
    store.dispatch('camp/auth/removeUser');
    next({ name: 'camp.auth.login', params: { language: store.getters['localization/getLanguage'] } });
  }
};
